import type { ClinicSwitcherProps } from '@/components/ClinicSwitcher.types';
import { useRecordingState } from '@/contexts/RecordingContext';
import { useClinicSwitch } from '@/hooks/useClinicSwitch';
import { OrgSwitcher } from '@careflux/auth';

const SWITCH_LABEL = 'Skipta um stofnun';
const RECORDING_BLOCKS_SWITCH = 'Ljúktu upptökunni áður en þú skiptir um stofnun';

/** Scribe's org picker: the shared switcher, blocked while a recording runs. */
export const ClinicSwitcher = ({ reloadWindow = () => window.location.reload() }: ClinicSwitcherProps) => {
  const { isActive } = useRecordingState();
  const { memberships, currentAccountId, switchTo, isSwitching, pendingAccountId } = useClinicSwitch({
    onEntered: reloadWindow,
  });

  return (
    <OrgSwitcher
      memberships={memberships}
      currentAccountId={currentAccountId}
      onSelect={switchTo}
      labels={{ trigger: SWITCH_LABEL, heading: SWITCH_LABEL }}
      disabledReason={isActive ? RECORDING_BLOCKS_SWITCH : undefined}
      isSwitching={isSwitching}
      pendingAccountId={pendingAccountId}
    />
  );
};
